import { IObjectLookup, IParam, TMapLookup } from "./interfaces";

export function mapToArray<T>(map: TMapLookup<T>): T[] {
    return Array.from(map.values());
}
export function mapToObject<T>(map: TMapLookup<T>) {
    const obj: IObjectLookup<T> = {};
    map.forEach((value, key) => obj[key] = value);
    return obj;
}
export function transformMapToParamList(initialize: TMapLookup<any>): IParam[] {
    const paramList: IParam[] = [];
    initialize.forEach((paramValue, paramName) => paramList.push({ paramName, paramValue }));
    return paramList;
}
export function sortByOrderASC(input1: { order: number }, input2: { order: number }): number {
    return input1.order - input2.order;
}
export function sortByOrderDES(input1: { order: number }, input2: { order: number }): number {
    return input2.order - input1.order;
}
/** Function to return first part of an association before / */
export function getAssociation(input: string): string {
    return input.split("/")[0];
}
/** Function to return the path from constrain. For example [a/b/c/d]=> a/b/c */
export function getPathFromConstraint(input: string): string {
    const lastIndex = input.lastIndexOf("/");
    return input.substring(1, lastIndex);
}
